import { mode, transparentize } from '@chakra-ui/theme-tools';
const baseStyle = {
    px: '8px',
    textTransform: 'initial',
    fontSize: 'sm',
    borderRadius: 'full',
    fontWeight: 'semibold',
};
const getSolidVariant = (props) => {
    const { colorScheme: c, theme } = props;
    const colorSchemes = {
        gray: {
            bg: mode(transparentize('gray.400', 0.1)(theme), transparentize('gray.200', 0.16)(theme))(props),
            color: mode('gray.600', 'white')(props),
        },
        default: {
            bg: mode(`${c}.500`, `${c}.400`)(props),
            color: mode('white', 'gray.600')(props),
        },
    };
    const colorScheme = colorSchemes[c] || colorSchemes.default;
    return {
        ...colorScheme,
        lineHeight: '1.25rem',
    };
};
const getSubtleVariant = (props) => {
    const { colorScheme: c, theme } = props;
    const colorSchemes = {
        gray: {
            bg: mode(transparentize('gray.400', 0.1)(theme), transparentize('gray.200', 0.16)(theme))(props),
            color: mode('gray.600', 'white')(props),
        },
        yellow: {
            bg: mode(transparentize('yellow.300', 0.1)(theme), transparentize('yellow.300', 0.16)(theme))(props),
            color: mode('yellow.600', 'yellow.300')(props),
        },
        default: {
            bg: mode(transparentize(`${c}.500`, 0.1)(theme), transparentize(`${c}.400`, 0.16)(theme))(props),
            color: mode(`${c}.600`, `${c}.300`)(props),
        },
    };
    const colorScheme = colorSchemes[c] || colorSchemes.default;
    return {
        ...colorScheme,
        lineHeight: '1rem',
    };
};
const variants = {
    solid: getSolidVariant,
    subtle: getSubtleVariant,
};
export default {
    baseStyle,
    variants,
};
//# sourceMappingURL=badge.js.map